<template>
    <div 
      class="  px-10 mt-12">
      <v-layout wrap>
        <v-flex>
          <section>
            
            <div class="color-dark-blue fs-22 font-weight-bold">
              Tambahkan Staff
            </div>
  
            <v-row
              class="">
              <v-col 
                cols="10"
                class="px-0">
                <v-card 
                  flat
                  min-height="calc(100vh - 245px)"
                  style="background: transparent;">
                  <v-card-text>
                    <ValidationObserver 
                      ref="form">
                      <v-form>
                        <!-- <div
                          class="mb-4">
                          <div 
                            class="body-2 mb-2">
                            Poto Profil
                          </div>
  
                          <uploadfolder v-if="form.image_url === ''"
                            v-model="upload.image">
                            <div 
                              slot="activator">
                              <v-card 
                                flat
                                width="200"
                                height="200"
                                class="d-flex align-center justify-center cursor-pointer"
                                style="border-radius: 15px;
                                      border: 2px solid #EBEBEB; 
                                      border-style: dashed;">
                                <v-avatar v-if="!process.image"
                                  v-ripple
                                  tile 
                                  width="200"
                                  height="200">
                                  <v-icon
                                    size="50"
                                    color="#B9B9B9">
                                    mdi-cloud-upload-outline
                                  </v-icon>
                                </v-avatar>
  
                                <v-progress-circular v-else
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </v-card>
                            </div>
                          </uploadfolder>
  
                          <v-card v-if="form.image_url !== ''"
                            flat
                            width="200"
                            height="200"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #EBEBEB; 
                                  border-style: dashed;">
                            <v-avatar
                              v-ripple
                              tile 
                              size="200"
                              style="border-radius: 15px;">
                              <v-img 
                                contain
                                width="100%"
                                height="100%"
                                alt="Distributor Amanata" 
                                :src="form.image_url"
                                class="ma-auto"
                                style="border-radius: 15px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
  
                            <v-icon 
                              @click="form.image_url = ''"
                              color="red"
                              class="cursor-pointer"
                              style="position: absolute; top: -10px; right: -10px;">
                              mdi-close-circle
                            </v-icon>
                          </v-card>
                        </div> -->
  
                        <v-row>
                          
                          <v-col
                          cols="12"
                          md="6" class="pt-0 pr-8">

                            <ValidationProvider
                              name="Nama" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Nama
                              </div>
          
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
          
                                color="#4828a1"
                                placeholder="Nama"
          
                                
          
                                v-model="form.name"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider>

                            <ValidationProvider
                              name="Kode" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Kode
                              </div>
          
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
          
                                color="#4828a1"
                                placeholder="Kode"
          
                                
          
                                v-model="form.code"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider>
  
                            <ValidationProvider
                              name="Email" 
                              rules="required|email" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Email
                              </div>
          
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
          
                                color="#4828a1"
                                placeholder="Contoh. XXXX@gmail.com"
                                
          
                                v-model="form.email"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider>


                            <ValidationProvider
                              name="Mobilephone" 
                              rules="required|min:10|max:13" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Mobilephone
                              </div>

                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo

                                color="#4828a1"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                min="0"

                                placeholder="Contoh. 081XXXXXXXXX"

                                

                                v-model="form.mobilephone"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider>
                            
                            <ValidationProvider
                              name="Jenis Kelamin" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-15 label-input">
                                Jenis Kelamin
                              </div>

                              <v-select
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo

                                :color="set_color"
                                placeholder="Contoh. Laki-Laki"

                                
                                :items="['Laki-Laki', 'Perempuan']"
                                :item-color="set_color"

                                :error-messages="errors"
                                v-model="form.gender"
                                required
                                style="border-radius: 10px;">
                              </v-select>
                            </ValidationProvider>
          
                            <ValidationProvider
                              name="Alamat" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Alamat
                              </div>
          
                              <v-textarea
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
                                row="2"
          
                                color="#4828a1"
                                placeholder="Alamat"
          
                                
          
                                v-model="form.address"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-textarea>
                            </ValidationProvider>


                            <ValidationProvider
                              name="NIK" 
                              rules="required|min:16|max:16" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                NIK
                              </div>
          
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
          
                                color="#4828a1"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                min="0"
          
                                placeholder="No. NIK"
          
                                
          
                                v-model="form.nik"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider>
          
                            <ValidationProvider
                              name="No. Rekening" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                No. Rekening
                              </div>
          
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
          
                                color="#4828a1"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                min="0"
          
                                placeholder="No. Rekening"
          
                                
          
                                v-model="form.rek_number"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider>
          
                            <ValidationProvider
                              name="Nama Rekening" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Nama Rekening
                              </div>
          
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
          
                                color="#4828a1"
                                placeholder="Nama Rekening"
          
                                
          
                                v-model="form.rek_name"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider>

                            <ValidationProvider
                              name="Nama Bank" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-15 label-input">
                                Nama Bank
                              </div>

                              <v-autocomplete
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo

                                :color="set_color"
                                placeholder="Contoh. BRI"

                                
                                :items="['BRI', 'BCA', 'CIMB', 'BNI', 'Mandiri', 'BTN', 'Danamon', 'Maybank', 'OCBC NISP', 'Panin', 'Permata', 'BTPN']"
                                :item-color="set_color"
                                v-model="form.bank_name"

                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider>


                            <div class="fs-15 label-input">
                            <!-- <span class="red--text">*</span> -->
                            
                              Tanggal Bergabung
                            </div>

                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                              >
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="Tanggal Bergabung" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <v-text-field
                                    v-model="form.join_date"
                                    
                                    v-on:keyup.enter="save()"
                                    
                                    filled
                                    solo
                                    rounded
                                    dense
                                    
                                    :color="set_color"
                                    placeholder="Tanggal Bergabung"
          
                                    :disabled="Object.keys(form).length < 1"
          
                                  
          
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                  </v-text-field>
                                </ValidationProvider>
                              </template>
                              <v-date-picker
                                v-model="form.join_date"
                                @input="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
  
                          </v-col>
                          
                          <v-col
                            cols="12"
                            md="6" class="pt-0 pl-8">

                            <div v-if="user.id !== '1'">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Cabang
                              </div>

                              <div class="fs-17 font-weight-bold label-input mb-10 pt-3">
                                {{ user.branch_name }}
                              </div>
                            </div>
                            <div v-if="user.id === '1'">
                              <ValidationProvider
                                name="Cabang" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  <!-- <span class="red--text">*</span> -->
                                  Cabang
                                </div>
          
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
          
                                  color="#4828a1"
                                  placeholder="Cabang"
          
                                  
                                  :items="branch"
                                  item-value="id"
                                  item-text="name"
                                  :item-color="set_color"
          
                                  v-model="form.branch_id"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </div>



                            <ValidationProvider
                              name="Kategori Pegawai" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Kategori Pegawai
                              </div>
        
                              <v-autocomplete
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
        
                                color="#4828a1"
                                placeholder="Kategori Pegawai"
        
                                
                                :items="category"
                                item-value="id"
                                item-text="title"
                                :item-color="set_color"
        
                                v-model="form.category_user_id"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider>


                            <ValidationProvider
                              name="Supervisor" 
                              rules="" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Supervisor
                              </div>
        
                              <v-autocomplete
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
        
                                color="#4828a1"
                                placeholder="Supervisor"
        
                                
                                :items="supervisor"
                                item-value="id"
                                item-text="name"
                                :item-color="set_color"
        
                                v-model="form.spv_id"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider>

  
                            <ValidationProvider
                              name="Deskripsi" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Deskripsi
                              </div>
          
                              <v-textarea
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
          
                                color="#4828a1"
                                placeholder="Deskripsi"
                                row="2"
          
                                
          
                                v-model="form.desc"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-textarea>
                            </ValidationProvider>
  
  
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Foto
                            </div>
                            <uploadfolder
                              v-model="upload.image_url" 
                              style="height: 150px; width: 150px;">
                              <div 
                                slot="activator"
                                class="cursor-pointer">
                                <v-card 
                                  flat
                                  height="150"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  <div v-if="form.image_url.length < 1">
                                    <v-icon v-if="!process.image_url"
                                      size="60" 
                                      color="#4828a1">
                                      mdi-cloud-upload-outline
                                    </v-icon>
  
                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </div>
  
                                  <v-img v-else
                                    contain
                                    height="150"
                                    :src="form.image_url" 
                                    :alt="form.image_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      <v-icon v-if="!process.image_url"
                                        size="60" 
                                        color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>
  
                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
                                  </v-img>
                                </v-card>
                              </div>
                            </uploadfolder>
  
                            <!-- <div v-if="message.ttd.length > 0"
                              class="text-center mt-6">
                              <div
                                class="error--text d-flex align-start">
                                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                                
                                <span
                                  class="ml-1">
                                  {{ message.ttd }}
                                </span>
                              </div>
                            </div> -->
                            <div class="mt-3">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Tanda Tangan
                              </div>
                              <uploadfolder
                                v-model="upload.ttd" 
                                style="height: 150px; width: 250px">
                                <div 
                                  slot="activator"
                                  class="cursor-pointer">
                                  <v-card 
                                    flat
                                    height="150"
                                    class="d-flex align-center justify-center"
                                    style="border-radius: 15px;
                                          border: 2px solid #eaeaea; 
                                          border-style: dashed;">
                                    <div v-if="form.ttd.length < 1">
                                      <v-icon v-if="!process.ttd"
                                        size="60" 
                                        color="#4828a1">
                                        mdi-cloud-upload-outline
                                      </v-icon>
    
                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
    
                                    <v-img v-else
                                      contain
                                      height="150"
                                      :src="form.ttd" 
                                      :alt="form.ttd"
                                      class="text-center d-flex align-center">
                                      <div 
                                        class="d-flex aling-center justify-center" 
                                        style="width: 100%; height: auto;">
                                        <v-icon v-if="!process.ttd"
                                          size="60" 
                                          color="white">
                                          mdi-cloud-upload-outline
                                        </v-icon>
    
                                        <v-progress-circular v-else
                                          indeterminate
                                          :color="set_color">
                                        </v-progress-circular>
                                      </div>
                                    </v-img>
                                  </v-card>
                                </div>
                              </uploadfolder>
                            </div>
  
  
                          </v-col>
                        </v-row>
  
                      </v-form>
                    </ValidationObserver>
  
                    <div v-if="message.error.length > 0"
                      class="text-center my-4 d-flex align-center">
                      <div
                        class="error--text">
                        <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              justify="end"
              class="pa-4 pr-1">
              <v-col 
                cols="12"
                md="12"
                class="d-flex align-center justify-end py-0">
                <v-btn 
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#6948c6"
                  class="fs-16 white--text text-capitalize border-radius">
                  Simpan
                </v-btn>
                
                <v-btn
                  to="/user/staff"
                  :disabled="process.form"
                  color="red"
                  elevation="0"
                  width="140"
                  height="45"
                  class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                  style="font-weight: 600;">
                
                    Batal
                </v-btn>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,


          form: {
            id: '',
            par_id: '0',
            category_user_id: '',
            branch_id: '',
            code: '',
            name: '',
            mobilephone: '',
            address: '',
            gender: '',
            email: '',
            nik: '',
            rek_number: '',
            rek_name: '',
            join_date: '',
            bank_name: '',
            image_url: '',
            desc: '',
            ttd: '',
            spv_id: '',
          },
          category: [],
          supervisor: [],
          branch: [],
  
          mobilephone: {
            name: '',
            id: ''
          },
  
          upload: {
            ttd: null,
            image_url: null
          },
  
          process: {
            form: false,
  
            ttd: false,
  
            image_url: false
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        'upload.ttd': {
          handler: function () {
            if (this.upload.ttd) {
              this.process.ttd = this.upload.ttd.process
  
              if (!this.process.ttd) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.ttd = this.upload.ttd.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
  
        'upload.image_url': {
          handler: function () {
            if (this.upload.image_url) {
              this.process.image_url = this.upload.image_url.process
  
              if (!this.process.image_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.image_url = this.upload.image_url.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        }
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        this.fetchCatrgory()
        this.fetchCabang()
        this.fetchSupervisor()
      },
      methods: {
        async fetchCatrgory() {
  
           let params = {
            limit: 10000000000000,
            'id[nin]': '1,8'
          }
  
          await get(`admin/category_user/data`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.category = res.results.data
            }
          })
        },
        async fetchCabang() {
  
           let params = {
            limit: 10000000000000
          }
  
          await get(`admin/branch/data`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.branch = res.results.data
            }
          })
        },
        async fetchSupervisor() {
  
           let params = {
            limit: 10000000000000,
            'category_user_id': '5'
          }
  
          await get(`admin/user/data`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.supervisor = res.results.data
            }
          })
        },
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate()
          if (isValid) {
            let form = {
              ...this.form,
              branch_id: this.user.id !== '1' ? this.user.branch_id : this.form.branch_id
            }
            this.process.form = true
  
            // SAVE TO REST API
            await post(`admin/user/add`, {
              data: form
            })
            .then((response) => {
              let res = response.data
  
              this.process.form = false
  
              if (res.status === 200) {
  
                this.$router.push({ path: '/user/staff' })
  
              } else {
                this.message.error = res.message
              }
            })
            
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        }
      }
    }
  </script>